<template>
  <div
    :class="{
      'ai-dropdown': true,
      'is-open': isOpen,
    }"
    ref="dropdown"
  >
    <div class="ai-dropdown-toggle" @click="toggleDropdown" v-if="isCustom">
      <slot />
    </div>
    <div class="ai-dropdown-toggle" @click="toggleDropdown" v-else>
      {{ selectedOption ? selectedOption.text : placeholder }}
      <img src="../assets/images/icons/down.png" />
    </div>
    <ul v-show="isOpen" class="ai-dropdown-menu">
      <li
        v-for="(option, index) in options"
        :key="index"
        @click="selectOption(option)"
      >
        {{ option.text }}
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "AiDropdown",
  props: {
    options: {
      type: Array,
      required: true,
    },
    placeholder: {
      type: String,
      default: "",
    },
    isCustom: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isOpen: false,
      selectedOption: null,
    };
  },
  mounted() {
    document.body.addEventListener("click", this.handleGlobalClick);
  },
  beforeDestroy() {
    document.body.removeEventListener("click", this.handleGlobalClick);
  },

  methods: {
    toggleDropdown() {
      this.isOpen = !this.isOpen;
    },
    selectOption(option) {
      this.selectedOption = option;
      this.isOpen = false;
      this.$emit("option-selected", option);
    },
    handleGlobalClick(event) {
      const dropdownElement = this.$refs.dropdown;
      if (!dropdownElement.contains(event.target)) {
        this.isOpen = false;
      }
    },
  },
};
</script>

<style lang="less">
/* Add some basic styling for the dropdown */
.ai-dropdown {
  position: relative;
  display: inline-block;
  width: 100%;
}

.ai-dropdown-toggle {
  cursor: pointer;
  padding: 5px 10px;
  border-radius: 5px;
  font-size: 12px;
  text-align: left;
  font-weight: bold;
  position: relative;
  img {
    height: 18px;
    width: 18px;
    position: absolute;
    right: 3px;
    top: 3px;
    transition: transform 0.3s ease;
  }
}

.ai-dropdown.is-open .dropdown-toggle img {
  transform: rotate(180deg);
}

.ai-dropdown-menu {
  font-weight: bold;
  position: absolute;
  left: 0;
  background: rgba(0, 0, 0, 0.9);
  border-radius: 9px;
  bottom: 100%;
  list-style: none;
  padding: 0;
  margin: 0;
  border-radius: 5px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  color: #999999;
  min-width: 120px;
  z-index: 10;
  margin-bottom: 5px;
}

.ai-dropdown-menu li {
  cursor: pointer;
  transition: all 0.15s;
  font-size: 14px;
  padding: 0 8px;
  height: 32px;
  line-height: 32px;
}

.ai-dropdown-menu li:hover {
  background: rgba(255, 255, 255, 0.08);
  color: #ffffff;
}
</style>
